const switchColors: object = {
  "blue-gray": {
    input: "checked:bg-blue-gray-500",
    circle: "peer-checked:border-blue-gray-500",
    before: "peer-checked:before:bg-blue-gray-500",
  },
  gray: {
    input: "checked:bg-gray-900",
    circle: "peer-checked:border-gray-900",
    before: "peer-checked:before:bg-gray-900",
  },
  brown: {
    input: "checked:bg-brown-500",
    circle: "peer-checked:border-brown-500",
    before: "peer-checked:before:bg-brown-500",
  },
  "deep-orange": {
    input: "checked:bg-deep-orange-500",
    circle: "peer-checked:border-deep-orange-500",
    before: "peer-checked:before:bg-deep-orange-500",
  },
  orange: {
    input: "checked:bg-orange-500",
    circle: "peer-checked:border-orange-500",
    before: "peer-checked:before:bg-orange-500",
  },
  amber: {
    input: "checked:bg-amber-500",
    circle: "peer-checked:border-amber-500",
    before: "peer-checked:before:bg-amber-500",
  },
  yellow: {
    input: "checked:bg-yellow-500",
    circle: "peer-checked:border-yellow-500",
    before: "peer-checked:before:bg-yellow-500",
  },
  lime: {
    input: "checked:bg-lime-500",
    circle: "peer-checked:border-lime-500",
    before: "peer-checked:before:bg-lime-500",
  },
  "light-green": {
    input: "checked:bg-light-green-500",
    circle: "peer-checked:border-light-green-500",
    before: "peer-checked:before:bg-light-green-500",
  },
  green: {
    input: "checked:bg-green-500",
    circle: "peer-checked:border-green-500",
    before: "peer-checked:before:bg-green-500",
  },
  teal: {
    input: "checked:bg-teal-500",
    circle: "peer-checked:border-teal-500",
    before: "peer-checked:before:bg-teal-500",
  },
  cyan: {
    input: "checked:bg-cyan-500",
    circle: "peer-checked:border-cyan-500",
    before: "peer-checked:before:bg-cyan-500",
  },
  "light-blue": {
    input: "checked:bg-light-blue-500",
    circle: "peer-checked:border-light-blue-500",
    before: "peer-checked:before:bg-light-blue-500",
  },
  blue: {
    input: "checked:bg-blue-500",
    circle: "peer-checked:border-blue-500",
    before: "peer-checked:before:bg-blue-500",
  },
  indigo: {
    input: "checked:bg-indigo-500",
    circle: "peer-checked:border-indigo-500",
    before: "peer-checked:before:bg-indigo-500",
  },
  "deep-purple": {
    input: "checked:bg-deep-purple-500",
    circle: "peer-checked:border-deep-purple-500",
    before: "peer-checked:before:bg-deep-purple-500",
  },
  purple: {
    input: "checked:bg-purple-500",
    circle: "peer-checked:border-purple-500",
    before: "peer-checked:before:bg-purple-500",
  },
  pink: {
    input: "checked:bg-pink-500",
    circle: "peer-checked:border-pink-500",
    before: "peer-checked:before:bg-pink-500",
  },
  red: {
    input: "checked:bg-red-500",
    circle: "peer-checked:border-red-500",
    before: "peer-checked:before:bg-red-500",
  },
};

export default switchColors;
